import { gql } from '@apollo/client';

export const NEW_VERIFICATION = gql`
    {
        newVerification {
            externalId
            publicId
            plans {
                id
                name
            }
        }
    }
`;
